import gql from "graphql-tag"

const START_ADDRESS_MODIFICATION = gql`
  mutation startOrderModificationAddresses($modificationId: ID!, $input: AWSJSON!) {
    Order {
      startOrderModificationAddresses(modificationId: $modificationId, input: $input) {
        status
      }
    }
  }
`

export default START_ADDRESS_MODIFICATION
